module.exports = __webpack_public_path__ + "fonts/4312f1fbdcf4d54af4506dabdce08010-Roboto-Regular.ttf";